import { render, staticRenderFns } from "./supervisingDialog.vue?vue&type=template&id=64ad87d3&scoped=true"
import script from "./supervisingDialog.vue?vue&type=script&lang=js"
export * from "./supervisingDialog.vue?vue&type=script&lang=js"
import style0 from "./supervisingDialog.vue?vue&type=style&index=0&id=64ad87d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ad87d3",
  null
  
)

export default component.exports